export default defineNuxtRouteMiddleware(async () => {
  const user = await useDrupalUser()
  if (!user.canAccessToolbar) {
    return abortNavigation()
  }
})
